var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"layout"},[_c('layout-header'),_c('a-layout',{staticClass:"section",attrs:{"has-sider":true}},[_c('layout-sider'),_c('layout-content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }